import { createSlice } from "@reduxjs/toolkit";
import {
  addNewUserManagementReq,
  deleteUserManagementReq,
  fetchUserManagementListReq,
  updateUserManagementReq,
  fetchDashboardDataCount
} from "../../../../api/userApi/userManagementReq";
import { showToast } from "../../../constants/toast/toast";

const userManagementSlice = createSlice({
  name: "userManagementList",
  initialState: {
    loading: false,
    error: false,
    data: [],
  },
  reducers: {
    setLoading: (state) => {
      state.loading = true;
    },
    addData: (state, { payload }) => {
      state.loading = false;
      state.error = false;
      state.data = payload;
    },
    setError: (state) => {
      state.error = true;
      state.loading = false;
    },
  },
});

export const { setLoading, addData, setError } = userManagementSlice.actions;
export default userManagementSlice.reducer;


export const addNewUserManagement = async (data, dispatch) => {
  try {
    const res = await addNewUserManagementReq(data);
    dispatch(fetchUserManagementList());
    return res;
  } catch (error) {
    dispatch(setError());
    dispatch(setLoading());
    showToast("Error! Try Again!","error")
    throw new Error("");
  }
};

export const updateUserManagement = async (data, dispatch) => {
  try {
    const res = await updateUserManagementReq(data);
    dispatch(fetchUserManagementList());
  } catch (error) {
    dispatch(setError());
    dispatch(setLoading());
    showToast("Error! Try Again!","error")
    throw new Error("");
  }
};

export const deleteUserManagement = async (data, dispatch) => {
  try {
    const res = await deleteUserManagementReq(data);    
    dispatch(fetchUserManagementList());
    return res;
  } catch (error) {
    dispatch(setError());
    dispatch(setLoading());
    showToast("Error! Try Again!","error")
    throw new Error("");
  }
};

export const fetchUserManagementList = async () => {
  try {
    
    (setLoading());
    const res = await fetchUserManagementListReq();
    (addData(res.data));
  } catch (error) {
    (setError());
  }
};

export const getDashboardDataCount = async () => {
  try {
    
    (setLoading());
    const res = await fetchDashboardDataCount();
    (addData(res.data));
    return res;
  } catch (error) {
    (setError());
  }
};
